<template>
  <div class="search-geo">
    <el-row :gutter="10">
      <el-form v-model="search">
        <el-col :md="6">
          <el-form-item>
            <el-date-picker v-model="search.dateRange"
                            format="dd-MM-yyyy"
                            type="daterange"
                            range-separator="A"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Seleccione inicio"
                            end-placeholder="Seleccione término">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item>
            <el-select v-model="search.regions"
                       placeholder="Región"
                       filterable
                       multiple
                       collapse-tags
                       no-match-text="No existen coincidencias"
                       no-data-text="Cargando..."
                       @change="getDataLocality"
                       clearable>
              <el-option  :label="selectBase"
                          :value="selectBase"
                          class="select-base"/>
              <el-option  v-for="region in regions"
                          :key="region.id"
                          :label="region.name"
                          :value="region.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4">
          <el-form-item>
            <el-select v-model="search.localities"
                       placeholder="Localidad (Máximo 1 región)"
                       filterable
                       multiple
                       collapse-tags
                       no-match-text="No existen coincidencias"
                       no-data-text="Cargando..."
                       :disabled="this.localitiesOfRegion.length < 1
                   || this.search.regions.length !== 1"
                       @change="selectAllLocality"
                       clearable>
              <el-option  :label="selectBase"
                          :value="selectBase"
                          class="select-base"/>
              <el-option  v-for="locality in localitiesOfRegion"
                          :key="locality.id"
                          :label="locality.name"
                          :value="locality.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4">
          <el-form-item>
            <el-select v-model="search.geoTypes"
                       placeholder="Geotipo"
                       filterable
                       multiple
                       collapse-tags
                       no-match-text="No existen coincidencias"
                       no-data-text="Cargando..."
                       @change="selectAllGeoTypes"
                       clearable>
              <el-option  :label="selectBase"
                          :value="selectBase"
                          class="select-base"/>
              <el-option  v-for="geoType in geoTypes"
                          :key="geoType.id"
                          :label="geoType.state"
                          :value="geoType.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4">
          <el-form-item>
            <el-select v-model="search.documentTypes"
                       placeholder="Tipo"
                       filterable
                       multiple
                       collapse-tags
                       no-match-text="No existen coincidencias"
                       no-data-text="Cargando..."
                       @change="selectAllDocumentTypes"
                       clearable>
              <el-option  :label="selectBase"
                          :value="selectBase"
                          class="select-base"/>
              <el-option  v-for="documentType in documentTypes"
                          :key="documentType.id"
                          :label="documentType.type"
                          :value="documentType.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="1">
          <el-form-item>
            <el-button  class="default"
                        @click="handleSearch">
              <i class="fa fa-search"/>
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <div class="filter-type">
      <span class="name">orden de resultados</span>
      <el-radio-group v-model="search.order">
        <el-radio-button :label="true">a-z</el-radio-button>
        <el-radio-button :label="false">z-a</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { cachedAPIRequest } from '@/mixins/cacheDim';

export default {
  name: 'Search',
  data() {
    return {
      selectBase: 'Seleccionar todos',
      search: {
        order: true,
        dateRange: null,
        regions: [],
        localities: [],
        geoTypes: [],
        documentTypes: [],
      },
      regions: [],
      localities: [],
      geoTypes: [],
      documentTypes: [],
    };
  },
  mounted() {
    this.getRegions();
    this.getLocalities();
    this.getGeoTypes();
    this.getDocumentTypes();
  },
  methods: {
    handleSearch() {
      if (this.search.regions.length < 1 || !this.search.dateRange) {
        this.$notify.warning({
          title: 'Advertencia',
          message: 'Fechas y región son campos obligatorios',
        });
      } else {
        this.$emit('search', this.search);
      }
    },
    getDataLocality(value) {
      if (value.includes(this.selectBase)) this.search.regions = this.regions.map(r => r.id);
      this.search.localities = [];
    },
    selectAllLocality(value) {
      if (value.includes(this.selectBase)) {
        this.search.localities = this.localitiesOfRegion.map(r => r.id);
      }
    },
    selectAllDocumentTypes(value) {
      if (value.includes(this.selectBase)) {
        this.search.documentTypes = this.documentTypes.map(r => r.id);
      }
    },
    selectAllGeoTypes(value) {
      if (value.includes(this.selectBase)) {
        this.search.geoTypes = this.geoTypes.map(r => r.id);
      }
    },
    getRegions() {
      cachedAPIRequest({
        module: 'planning',
        service: 'regions',
        params: { limit: 1000 },
      }).then((response) => {
        this.regions = response.data
          .sort((a, b) => (b.name > a.name ? -1 : 1));
        this.search.regions = response.data.map(r => r.id);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar regiones',
        });
      });
    },
    getLocalities() {
      cachedAPIRequest({
        module: 'crud',
        service: 'get_localities',
        params: { limit: 2500 },
      }).then((response) => {
        this.localities = response.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las localidades',
        });
      });
    },
    getDocumentTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'document_type',
        params: { limit: 1000 },
      }).then((response) => {
        this.documentTypes = response.data;
        this.search.documentTypes = response.data.map(r => r.id);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar regiones',
        });
      });
    },
    getGeoTypes() {
      cachedAPIRequest({
        module: 'crud',
        service: 'get_geo_states',
        params: { limit: 1000 },
      }).then((response) => {
        this.geoTypes = response.data;
        this.search.geoTypes = response.data
          .filter(r => ['Centroide', 'No encontrado'].includes(r.state)).map(r => r.id);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar geotipos',
        });
      });
    },
  },
  computed: {
    localitiesOfRegion() {
      return this.localities
        .filter(l => this.search.regions.includes(l.commune.regions_id))
        .sort((a, b) => (b.name > a.name ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-geo {
    .el-form-item { margin-bottom: 10px; }
    .filter-type {
      margin-bottom: 10px;
      .name {
        margin-right: 10px;
        vertical-align: sub;
      }
      .el-radio-group, .el-checkbox-group { margin-right: 14px; }
    }
  }
  .select-base {
    font-weight: 600;
    border-bottom: 1px solid $fb-grey-light-92;
  }
</style>
